import { Component, ViewChild, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatInputModule, MatInput, MatFormField, MatLabel } from '@angular/material/input';
import { MatAutocompleteModule, MatAutocompleteTrigger, MatAutocomplete, MatOption } from '@angular/material/autocomplete';
import { Observable, of } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
@Component({
    selector: 'formly-autocomplete-type',
    templateUrl: 'autocomplete-type.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatFormField, MatLabel, MatInput, MatAutocompleteTrigger, FormsModule, ReactiveFormsModule, FormlyModule, MatAutocomplete, MatOption, AsyncPipe, MatFormFieldModule, MatInputModule, MatSelectModule, MatAutocompleteModule]
})
export class AutoCompleteTypeComponent extends FieldType implements OnInit {
    @ViewChild(MatInput) formFieldControl: MatInput;
    @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
    filter: Observable<any>;
    ngOnInit(): any {
        if (!this.to.filter) {
            this.to.filter = (term: string): any => {
                term = term?.toString() || '';
                const options: any[] = this.to.options as any[] || [];
                const filtered = options.filter(v => v.label.toLowerCase().indexOf(term.toLowerCase()) >= 0);
                return of(filtered);
            };
        }
        this.filter = this.formControl.valueChanges
            .pipe(
                startWith(''),
                switchMap(term => this.to.filter(term)),
            );
    }

    getLabel(value: number): any {
        const options: any[] = this.to.options as any[] || [];
        const filtered = options.find(v => v.value === value);
        return filtered ? filtered.label : '';
    }
}
